import { call, takeLatest, put } from 'redux-saga/effects';
import { resourceService } from '@libs/axios';
import dayjs from "dayjs";

import {
  setAdminReporting1aData,
  setAdminReporting2aData,
  setAdminReporting1bData,
  setLoading,
  setAdminReportingFilter,
  setAdminReporting2aFilter,
  setDownloadReportData1aUrl,
  setDownloadReportData2aUrl,
  setDownloadReportData1bUrl,
  setLoadingReporting,
  setAdminReportingDetail,
  setStudentReportingDetail,
  setExamsReporting,
  setDownloadExamsReportingUrl,
  setLoadingExamsReporting,
  setExamsReportingDetail,
  setListClassModule,
  
} from '@store/reducers/reportingReducer';
import {
  fetchReportingFilters1a,
  fetchReportingFilters2a,
  fetchReportingFilters1b,
  fetchReportingFilterData,
  fetchReporting2aFilterData,
  fetchAdminReportingDetail,
  fetchStudentReportingDetail,
  fetchReportingExamsFilterDataType,
  fetchExamsReportingDetail,
  fetchListClassModulesFromReporting

} from '@store/actions/reportingAction';

import { ResponseType } from '@store/index';
const API_URL = process.env.REACT_APP_API_URL;

function* fetchReportingFilters1aSaga(
  action: ReturnType<typeof fetchReportingFilters1a>,
) {
  try {
    yield put(setLoading(true));
    const response: ResponseType = yield call(
      resourceService.get,
      API_URL + '/api/admin_report_1a/',
      {
        params: { ...action.payload, size: 100 },
      },
    );
    const dataUrl: ResponseType = yield call(
      resourceService.get,
      API_URL + '/api/admin_report_1a/',
      {
        params: { ...action.payload, size: 100, export_data: true },
      },
    );
    if (response.status === 200) {
      yield put(setAdminReporting1aData(response.data));
      yield put(setLoading(false));
    }
    if (dataUrl?.data?.file_url) {
      yield put(setDownloadReportData1aUrl(dataUrl?.data?.file_url));
    }
  } catch (error) {
    console.error(error);
    yield put(setLoading(false));
  }
}
function* fetchReportingFilters2aSaga(
  action: ReturnType<typeof fetchReportingFilters2a>,
) {
  const { province2, ward2, school, classes, module, submodule, page, page_size, from_date, to_date }=action.payload
  try {
    if (action.payload?.export_data === true) {
      yield put(setLoadingReporting(true));
      //@ts-ignored
      const dataUrl = yield call(resourceService.get, API_URL + '/api/admin_report_3a_v2/', {
        params: { ...action.payload, export_data: true },
      });

      if (dataUrl.status === 200 && dataUrl.data?.file_url) {
        const anchor = document.createElement('a');
        anchor.href = dataUrl.data.file_url;
        anchor.download = 'report.xlsx';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      }
      yield put(setLoadingReporting(false));
      return;
    }

    yield put(setLoading(true));
    yield put(setLoadingReporting(true));
    //@ts-ignored
    const response = yield call(resourceService.get, API_URL + '/api/admin_report_3a_v2/', {
      params: { province2, ward2, school, classes, module, submodule, page, page_size, from_date, to_date },
    });

    if (response.status === 200) {
      yield put(setAdminReporting2aData(response.data));
    }
    yield put(setLoading(false));
    yield put(setLoadingReporting(false));
  } catch (error) {
    console.error(error);
    yield put(setLoading(false));
    yield put(setLoadingReporting(false));
  }
}

function* fetchReportingFilters1bSaga(
  action: ReturnType<typeof fetchReportingFilters1b>,
) {
  try {
    yield put(setLoading(true));
    const response: ResponseType = yield call(
      resourceService.get,
      API_URL + '/api/admin_report_1b/',
      {
        params: { ...action.payload, size: 100 },
      },
    );
    if (response.status === 200) {
      yield put(setAdminReporting1bData(response.data));
      yield put(setLoading(false));
    }
    const dataUrl: ResponseType = yield call(
      resourceService.get,
      API_URL + '/api/admin_report_1b/',
      {
        params: { ...action.payload, size: 100, export_data: true },
      },
    );
    if (response.status === 200) {
      yield put(setAdminReporting1bData(response.data));
      yield put(setLoading(false));
    }
    if (dataUrl?.data?.file_url) {
      yield put(setDownloadReportData1bUrl(dataUrl?.data?.file_url));
    }
  } catch (error) {
    console.error(error);
    yield put(setLoading(false));
  }
}

function* fetchReportingFilterDataSaga(
  action: ReturnType<typeof fetchReportingFilterData>,
) {
  try {
    const response: ResponseType = yield call(
      resourceService.get,
      API_URL + '/api/admin_dashboard_api_filter',
      {
        params: { ...action.payload },
      },
    );
    if (response.status === 200) {
      yield put(setAdminReportingFilter(response.data));
    }
  } catch (error) {
    console.error(error);
  }
}
function* fetchReporting2aFilterDataSaga(
  action: ReturnType<typeof fetchReporting2aFilterData>,
) {
  try {
    //@ts-ignored
    const response = yield call(
      resourceService.get,
      API_URL + '/api/admin_dashboard_api_filter',
      {
        params: { ...action.payload },
      },
    );
    if (response.status === 200) {
      yield put(setAdminReporting2aFilter(response.data));
    }
  } catch (error) {
    console.error(error);
  }
}
function* fetchAdminReportingDetailSaga(
  action: ReturnType<typeof fetchAdminReportingDetail>,
) {
  try {
    const { submodule_id, student_id } = action.payload;
    const response: ResponseType = yield call(
      resourceService.get,
      API_URL + '/api/admin_report_detail/',
      {
        params: { submodule_id, student_id },
      },
    );
    if (response.status === 200) {
      yield put(setAdminReportingDetail(response.data));
    }
  } catch (error) {
    console.error(error);
  }
}
function* fetchStudentReportingDetailSaga(
  action: ReturnType<typeof fetchStudentReportingDetail>,
) {
  try {
    const { submodule_id } = action.payload;
    const response: ResponseType = yield call(
      resourceService.get,
      API_URL + '/api/student_report_detail/',
      {
        params: { submodule_id },
      },
    );
    if (response.status === 200) {
      yield put(setStudentReportingDetail(response.data));
    }
  } catch (error) {
    console.error(error);
  }
}
function* fetchExamsReportingSaga(action: ReturnType<typeof fetchReportingExamsFilterDataType>) {
  try {
    const payload = {
      ...action.payload,
      from_date: action.payload?.from_date ? dayjs(action.payload.from_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : action.payload?.from_date,
      to_date: action.payload?.to_date ? dayjs(action.payload.to_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : action.payload?.to_date,
    };

    if (payload?.export_data && payload?.export_data === true) {
      //@ts-ignored
      const dataUrl = yield call(resourceService.get, API_URL + '/api/report_exam/', {
        params: { ...payload, export_data: true }
      })
      if (dataUrl.status === 200) {
        const anchor = document.createElement('a');
        anchor.href = dataUrl.data?.file_url;
        anchor.download = 'report_exams.xlsx';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      }
    } else {
      yield put(setLoadingExamsReporting(true))
      //@ts-ignored
      const response = yield call(resourceService.get, API_URL + '/api/report_exam/', {
        params: { ...payload }
      })
      if (response.status === 200) {
        yield put(setExamsReporting(response.data))
        yield put(setLoadingExamsReporting(false))
      }
    }
  }
  catch (error) {
    console.error(error)
    yield put(setLoadingExamsReporting(false))
  }
}
function* fetchExamsReportingDetailSaga(
  action: ReturnType<typeof fetchExamsReportingDetail>,
) {
  try {
    const { submodule_id, student_id } = action.payload;
    const response: ResponseType = yield call(
      resourceService.get,
      API_URL + '/api/report_exam_detail/',
      {
        params: { submodule_id, student_id },
      },
    );
    if (response.status === 200) {
      yield put(setExamsReportingDetail(response.data.data));
    }
  } catch (error) {
    console.error(error);
  }
}
function* fetchListModuleClassSaga(
    action: any,
) {
    yield put(setLoading(true));
    try {
        const { pageSize, page, status, classId } = action.payload;
        let response : ResponseType;
        if (status !== undefined && status !== null) {
            response = yield call(
                resourceService.get,
                API_URL + `/api/classes/${classId}/modules/?status=${status}`,
            );
        } else {
            response = yield call(
                resourceService.get,
                API_URL + `/api/classes/${classId}/modules/`,
            );
        }
        if (response.status == 200) {
            yield put(setLoading(false));
            yield put(setListClassModule(response?.data));
        }
    } catch (error) {
        yield put(setLoading(false));
    }
}
function* adminReportingSaga() {
  yield takeLatest(fetchReportingFilters1a, fetchReportingFilters1aSaga);
  yield takeLatest(fetchReportingFilters2a, fetchReportingFilters2aSaga);
  yield takeLatest(fetchReportingFilters1b, fetchReportingFilters1bSaga);
  yield takeLatest(fetchReportingFilterData, fetchReportingFilterDataSaga);
  yield takeLatest(fetchReporting2aFilterData, fetchReporting2aFilterDataSaga);
  yield takeLatest(fetchAdminReportingDetail, fetchAdminReportingDetailSaga);
  yield takeLatest(fetchStudentReportingDetail, fetchStudentReportingDetailSaga);
  yield takeLatest(fetchReportingExamsFilterDataType, fetchExamsReportingSaga);
  yield takeLatest(fetchExamsReportingDetail, fetchExamsReportingDetailSaga);
  yield takeLatest(fetchListClassModulesFromReporting as any, fetchListModuleClassSaga);
  
}

export default adminReportingSaga;
